import React from 'react'

import './styles.scss'

import backgroundImg from './img/background.jpg'
import separatorImg from './img/separator.png'

import { IntroProps } from '../types'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

const Intro = ({
  coupleData: { coupleSingleName, weddingDate },
  buttonMessage,
  warningMessage,
  locale = 'pt-BR',
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  const date = new Intl.DateTimeFormat(locale)
    .format(new Date(weddingDate.timestamp))
    .replace(/\//g, ' • ')

  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro234">
      <div className="bp1-intro234mobile anima-word-break">
        <img
          alt="Image/"
          src={background || backgroundImg}
          className="bp1-mainbackground"
        />
        <div className="bp1-mask"></div>
        <div className="bp1-button-layout-container">
          <div className="bp1-button">
            <div
              className="bp1-sitedecasamentoe"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="bp1-button1" onClick={onSkipIntro}>
              <div className="bp1-button2"></div>
              <div className="bp1-pularintrodu347343o">{buttonMessage}</div>
            </div>
          </div>
        </div>
        <div className="bp1-content-layout-container">
          <div className="bp1-content">
            <div className="bp1-namesdate-layout-container">
              <div className="bp1-namesdate bp1-intro234-anima-animate-enter3">
                <div className="bp1-dayu2022mouthu2022y-layout-container">
                  <div className="bp1-dayu2022mouthu2022y bp1-intro234-anima-animate-enter">
                    {date}
                    <br />
                  </div>
                </div>
                {!!coupleSingleName.groom && (
                  <>
                    <div className="notranslate bp1-couplesinglenamegr bp1-intro234-anima-animate-enter1">
                      {coupleSingleName.groom}
                    </div>
                    <img
                      alt="Image/"
                      src={separatorImg}
                      className="bp1-image1"
                    />
                  </>
                )}

                <div
                  style={!coupleSingleName.groom ? { top: 120 } : {}}
                  className="notranslate bp1-couplesinglenamebr bp1-intro234-anima-animate-enter2"
                >
                  {coupleSingleName.bride}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bp2-intro234desktop anima-word-break">
        <img
          alt="Image/"
          src={background || backgroundImg}
          className="bp2-mainbackground"
        />
        <div className="bp2-mask"></div>
        <div className="bp2-button-layout-container">
          <div className="bp2-button">
            <div
              className="bp2-sitedecasamentoe"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="bp2-button1" onClick={onSkipIntro}>
              <div className="bp2-button2"></div>
              <div className="bp2-pularintrodu347343o">{buttonMessage}</div>
            </div>
          </div>
        </div>
        <div className="bp2-content-layout-container">
          <div className="bp2-content">
            <div className="bp2-namesdate-layout-container">
              <div className="bp2-namesdate bp2-intro234-anima-animate-enter3">
                <div className="bp2-dayu2022mouthu2022y bp2-intro234-anima-animate-enter">
                  {date}
                </div>

                {!!coupleSingleName.groom && (
                  <>
                    <div className="notranslate bp2-couplesinglenamegr bp2-intro234-anima-animate-enter1">
                      {coupleSingleName.groom}
                    </div>
                    <img
                      alt="Image/"
                      src={separatorImg}
                      className="bp2-image1"
                    />
                  </>
                )}
                <div
                  style={!coupleSingleName.groom ? { top: 120 } : {}}
                  className="notranslate bp2-couplesinglenamebr bp2-intro234-anima-animate-enter2"
                >
                  {coupleSingleName.bride}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
